// src/components/Report/shared/NoData.jsx
import React from "react";

export default function NoData({ message = "No data for this period" }) {
  return (
    <div className="dlg-no-data">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
        <path d="M3 3v18h18" />
        <path d="m7 16 4-4 4 4 4-4" />
      </svg>
      <span className="dlg-no-data-text">{message}</span>
    </div>
  );
}